export default "__VITE_ASSET__BcfW0_h4__"